'use client';
export { default } from '@corekit/core/src/app/error';
